import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { agreementVersion, TermsOfServiceSummaryText, TermsOfSeviceFullText } from './TermsOfServiceText';
import StepsLayout from '../utilities/layouts/StepsLayout';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { FONT_WEIGHT_BOLD } from '../utilities/Material';
import { Typography, useMediaQuery } from '@material-ui/core/';
import { styleBreakDesktop, styleBreakMobile, styleBreakSmallMobile } from '../utilities/layouts/Globals';
import Paper from '@material-ui/core/Paper';
import { COLOR_WHITE } from '../utilities/Material';
import Box from '@material-ui/core/Box';
import { PrimaryButton } from '../utilities/commonUtilities/GenericButtonElements';

const useStyles = makeStyles(theme => ({
    // Need to override to make the scroll bar take up no space.
    stepsContainer: {
        height: '100vh',
        overflowY: 'overlay',
        [theme.breakpoints.down(theme.breakpoints.values['lg'])]: {
            background: COLOR_WHITE,
        },
    },
    textContainer: {
        borderRadius: 4,
        marginBottom: theme.spacing(6),
        [styleBreakDesktop(theme)]: {
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            marginBottom: theme.spacing(12),
        },
        [styleBreakMobile(theme)]: {
            paddingTop: theme.spacing(3),
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
        [styleBreakSmallMobile(theme)]: {
            paddingTop: theme.spacing(2),
        },
    },
    readMoreText: {
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'start',
        fontWeight: FONT_WEIGHT_BOLD,
        color: theme.palette.primary.dark,
        marginTop: theme.spacing(4),
        paddingBottom: theme.spacing(5),
        marginBottom: theme.spacing(1) + 3,
        [styleBreakMobile(theme)]: {
            textAlign: 'center',
            marginTop: 'auto',
            paddingBottom: 0,
        },
    },
    staticFooter: {
        padding: `${theme.spacing(2)}px 0`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        marginTop: 'auto',
        [styleBreakDesktop(theme)]: {
            alignItems: 'flex-start'
        }
    },
    staticFooterAccept: {
        width: '100%',
    }
}));

const SetupAccountStep2TermsOfService = ({ currentPage, onNextPage, onPreviousPage, setAgreementVersion, onCancel }) => {
    const [showFullText, setShowFullText] = useState(false);
    const style = useStyles();
    const theme = useTheme();
    const mobileview = useMediaQuery(theme.breakpoints.down('md'));

    // Don't draw the component if it is not our page.
    if (currentPage !== 2) {
        return null;
    }

    const onShowFullText = () => {
        setShowFullText(true);
    };

    const cancelClickHandler = () => {
        setShowFullText(false);
    };

    const onAccept = () => {
        setAgreementVersion(agreementVersion);
        onNextPage();
    };

    // when Full ToS is displayed, clicking back arrow will go to Summary ToS.
    // when Summary ToS is displayed, clicking back arrow will go to previous page.
    const onPrevious = showFullText ? cancelClickHandler : onPreviousPage;
    const readMoreVisibility = showFullText ? 'none' : 'block';

    return (
        <StepsLayout
            onPrevClick={showFullText ? onPrevious : null}
            onCancelClick={onCancel}
            currentCount={1}
            totalCount={4}
            titleText={'Terms of Service'}
            nextButtonText={'Accept'}
            isNextButtonDisabled={false}
            id={'Accept-button-of-terms-service'}
            onNextClick={onAccept}
            backgroundStretch={true}
            stepsContainerClass={style.stepsContainer}
            showFooter={!mobileview}
        >
            <Paper elevation={0} className={style.textContainer}>
                {showFullText ? <TermsOfSeviceFullText /> : <TermsOfServiceSummaryText />}

                <Box className={style.staticFooter}>
                    <Typography onClick={onShowFullText} className={style.readMoreText} style={{ display: readMoreVisibility }}>
                        Read the Full Terms of Service
                    </Typography>

                    {mobileview && (
                        <PrimaryButton onClick={onAccept} className={style.staticFooterAccept}>
                            Accept
                        </PrimaryButton>
                    )}
                </Box>
            </Paper>
        </StepsLayout>
    );
};

/* type checking for props */
SetupAccountStep2TermsOfService.propTypes = {
    currentPage: PropTypes.number.isRequired,
    onNextPage: PropTypes.func.isRequired,
    onPreviousPage: PropTypes.func.isRequired,
};

export default SetupAccountStep2TermsOfService;
